(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["little-roots-transliterator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTL(root) {
    if (root.dataset.tlReady) return;
    root.dataset.tlReady = '1';

    var input  = root.querySelector('.lr-tl-input');
    var select = root.querySelector('.lr-tl-select');
    var result = root.querySelector('.lr-tl-result');
    var roman  = root.querySelector('.lr-tl-roman');
    var count  = root.querySelector('.lr-tl-count');
    if (!input || !result) return;

    var maxlen   = parseInt(root.dataset.maxlen, 10) || 20;
    var provider = (root.dataset.provider || 'google').trim();
    var endpoint = (root.dataset.endpoint || '').trim();
    var def      = result.getAttribute('data-default') || '';
    var ctrl = null, timer = null;

    function setCount() { if (count) count.textContent = input.value.length + '/' + maxlen; }

    function buildUrl(text, code) {
      var t = encodeURIComponent(text);
      if (provider === 'custom' && endpoint) {
        return endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'text=' + t + '&lang=' + encodeURIComponent(code);
      }
      return 'https://inputtools.google.com/request?itc=' + encodeURIComponent(code) +
             '-t-i0-und&num=1&cp=0&cs=1&ie=utf-8&oe=utf-8&text=' + t;
    }

    function parse(data) {
      try {
        if (data && typeof data.result === 'string') return data.result;
        if (Array.isArray(data) && data[0] === 'SUCCESS') return data[1][0][1][0];
      } catch (e) {}
      return null;
    }

    function render(text) {
      var code = select ? select.value : '';
      if (roman) roman.textContent = (code === 'en') ? '' : (text || '');

      if (!text) {
        result.textContent = def;
        result.classList.remove('lr-tl-fallback', 'lr-tl-en');
        root.classList.remove('lr-loading');
        return;
      }
      if (code === 'en') {
        if (ctrl) ctrl.abort();
        root.classList.remove('lr-loading');
        result.textContent = text;
        result.classList.remove('lr-tl-fallback');
        result.classList.add('lr-tl-en');
        return;
      }
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      root.classList.add('lr-loading');

      fetch(buildUrl(text, code), { signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          root.classList.remove('lr-loading');
          var out = parse(d);
          result.classList.remove('lr-tl-en');
          if (out) { result.textContent = out; result.classList.remove('lr-tl-fallback'); }
          else     { result.textContent = text; result.classList.add('lr-tl-fallback'); }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          root.classList.remove('lr-loading');
          result.textContent = text;
          result.classList.add('lr-tl-fallback');
        });
    }

    function onInput() {
      if (input.value.length > maxlen) input.value = input.value.slice(0, maxlen);
      setCount();
      clearTimeout(timer);
      var v = input.value.trim();
      timer = setTimeout(function () { render(v); }, 300);
    }

    input.addEventListener('input', onInput);
    if (select) select.addEventListener('change', function () { render(input.value.trim()); });
    setCount();
  }

  function initAll() {
    var nodes = document.querySelectorAll('.lr-tl');
    for (var i = 0; i < nodes.length; i++) initTL(nodes[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
